let defaults = {};

defaults.images = JSON.parse(brookingsAlgolia.default_images);

export default defaults;